import { IPerson } from "../../sg-hpr/models/IPerson";
import { IFormSchema } from "../interfaces/IFormSchema";
import IAudit from "../interfaces/IAudit";
import { auditFormDataToPersonIds } from "./data.helpers";
import _uniq from "lodash/uniq";

export interface TIdentifiersDTO {
    henkilot: string;
    kohteet: string;
};


export interface TIdentifiers {
    henkilot: Array<IPerson["id"]>;
    kohteet: Array<string>;
};


export const extractFormDataIdentifiers = (formData: IAudit["formData"], schema: IFormSchema): TIdentifiers => {
    const identifiers: TIdentifiers = {
        henkilot: [],
        kohteet: [],
    };

    const personIds = auditFormDataToPersonIds(formData, schema)
    identifiers.henkilot = personIds

    if (formData.kohde) {
        identifiers.kohteet = identifiers.kohteet.concat(formData.kohde as any)
    } else if (formData.sijainti) {
        identifiers.kohteet = identifiers.kohteet.concat(formData.sijainti as any)
    };

    if (formData.target) {
        identifiers.kohteet = identifiers.kohteet.concat(formData.target as any)
    };
    return identifiers
};


export const extractFormDataIdentifiersDTO = (formData: IAudit["formData"], formSchema: IFormSchema): TIdentifiersDTO | string => {
    const identifiers = extractFormDataIdentifiers(formData, formSchema);

    if (!identifiers.henkilot.length && !identifiers.kohteet.length) {
        return "n/a"
    };

    return {
        henkilot: _uniq(identifiers.henkilot).join(","),
        kohteet: _uniq(identifiers.kohteet).join(","),
    }
}

export const extractIdentifiersDTOFromAudit = (audit: IAudit): TIdentifiersDTO | string => {
    if (!audit.formSchema) {
        throw Error("Missing form configuration")
    }

    let identifiers = extractFormDataIdentifiers(audit.formData, audit.formSchema);

    if (audit.metaData.participants) {
        identifiers.henkilot = [...identifiers.henkilot, ...audit.metaData.participants];
    }

    if (!identifiers.henkilot.length && !identifiers.kohteet.length) {
        return "n/a"
    };

    return {
        henkilot: identifiers.henkilot.join(","),
        kohteet: identifiers.kohteet.join(","),
    }
}